import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = ProjectFestival[];

export const getProjectsFestival = createAppAsyncThunk(
  'projectFestival/getProjectsFestival',
  async (
    _,
    { extra: { projectFestivalGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const projects = await projectFestivalGateway.getAll();
      return projects;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetProjects.Message.error'));
}
